import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { eventTopicRredirectRules } from "../variables/eventTopicRredirectRules";

const useNotificationMessages = () => {
    let navigate = useNavigate();

    const initGlobalHandler = () => {
        if (Notification.permission !== "granted") {
            console.warn("Notifications are blocked. Skipping event listener registration.");
            return;
        }

        navigator.serviceWorker.addEventListener("message", (message) => {
            const data = message.data;
            if (!data || !data.notification) return;

            data.notification.payload = data.data;
            toast.success(`${data.notification.title}! ${data.notification.body}`);

            if (data.messageType === "notification-clicked" && !!data.notification.payload) {
                const event = eventTopicRredirectRules.find(
                    (item) => item.topic === data.notification.payload.topic
                );
                if (event) event.handleRedirect(data.notification.payload, navigate);
            }
            publish(data.notification);
        });
    };


    /**
     *
     * @param {
     *  title: string,
     *  body:string,
     *  payload: {
     *      id: string,
     *      topic: string
     *  }} event
     */
    const publish = (event) => {
        if (Notification.permission === 'granted') {
            console.log("PUBLISHED EVENT => ", event);
            window.postMessage(event);
        }
    };

    const subscribe = (topic, handler) => {
        if (Notification.permission === 'granted') {
            const messageEventHandler = (event) => {
                subscriptionHandler(event, topic, handler);
            };

            const attachEventListener = () => {
                window.addEventListener("message", messageEventHandler);
            };
            const detachEventListener = () => {
                window.removeEventListener("message", messageEventHandler);
            };

            attachEventListener();
            return { unsubscribe: detachEventListener };
        }
    };

    const subscriptionHandler = (event, topic, handler) => {
        if (Notification.permission === 'granted') {

            if (!event.data || !event.data.payload) {
                return;
            }
            if (event.data.payload.topic === topic) {
                handler(event.data);
            }
        };
    };

    return { initGlobalHandler, subscribe, publish };
};

export default useNotificationMessages;
